<template>
  <!-- Główny kontener listy naruszeń -->
  <!-- Dodatkowa klasa 'violations-step-1' usuwa dolną ramkę w kroku 1 -->
  <div class="violations ds-panel" :class="{ 'violations-step-1': step === 1 }">
    <!-- Nagłówek panelu: tłumaczenie klucza 'violations', wyświetlane wielkimi literami -->
    <div class="ds-panel__head">
      <h3 class="ds-panel__title">{{ t('violations').toUpperCase() }} %</h3>
    </div>

    <!-- Lista wyborów: jedna pozycja w wierszu, wybór po lewej stronie etykiety -->
    <div class="violations__list">
      <!-- Filtrowanie tylko oznaczonych pojazdów -->
      <div class="violations__row" :class="{ 'is-disabled': store.disabledFields?.violations }">
        <input-checkbox
          field-name="taggedOnly"
          field-value=""
          :checkedCondition="isChecked('taggedOnly')"
          @clicked="setFilter('taggedOnly')"
          :disabled="store.disabledFields?.violations"
        />
        <span class="violations__value">{{ t('tagged-only') }}</span>
      </div>

      <!-- Opcja "wszystkie" — wyróżniona jako zbiorcza -->
      <div
        class="violations__row violations__row--all"
        :class="{ 'is-disabled': store.disabledFields?.violations }"
      >
        <input-checkbox
          field-name="ViolationsAll"
          field-value=""
          :checkedCondition="isChecked('all')"
          @clicked="setFilter('ViolationsAll')"
          :disabled="store.disabledFields?.violations"
        />
        <span class="violations__value">{{ t('all') }}</span>
      </div>

      <!-- Iteracja po poszczególnych typach naruszeń -->
      <div
        class="violations__row"
        :class="{ 'is-disabled': store.disabledFields?.violations }"
        v-for="(item, index) in store.violations"
        :key="index"
      >
        <input-checkbox
          :field-name="index"
          field-value=""
          :checkedCondition="isChecked(index)"
          @clicked="setFilter(index)"
          :disabled="store.disabledFields?.violations"
        />
        <span class="violations__value">{{ item }}</span>  <!-- Tłumaczona nazwa naruszenia -->
      </div>
    </div>
  </div>
</template>

<script>
// Import komponentu checkbox do wielokrotnego użytku
import InputCheckbox from "../InputCheckbox.vue";

export default {
  name: "ViolationList",  // Nazwa komponentu
  props: {
    // Store z filtrami i danymi lokalizacji oraz dostępnymi naruszeniami
    store: { required: true },
    // Obecny krok procesu (np. 1 lub 2)
    step: { type: Number, default: 2 },
  },
  components: { InputCheckbox }, // Rejestracja komponentu InputCheckbox

  created() {
    // Przy tworzeniu komponentu ładujemy listę lokalizacji do store
    this.store.getLocations();
  },

  methods: {
    /**
     * Przełącza wartość filtra dla danego klucza:
     * Jeśli jest już ustawiony, usuwa go; w przeciwnym razie ustawia na true
     */
    setFilter(id) {
      const value = this.store.filters[id] ? false : true;
      this.store.addItem(id, value);
    },

    /**
     * Sprawdza, czy dany filtr jest zaznaczony:
     * - Dla 'all' sprawdzamy, czy wszystkie naruszenia są ustawione na true
     * - Inaczej zwracamy wartość boolean z store.filters
     */
    isChecked(id) {
      if (id === "all") {
        const filters = this.store.filters;
        // Sprawdzamy, czy nie ma żadnego naruszenia bez filtra true
        return !Object.keys(this.store.violations).some(key => filters[key] !== true);
      }
      return this.store.filters[id];
    },
  },
};
</script>

<style scoped>
/* Panel „Przekroczenia %" — lista pozycji, każda w osobnym wierszu
   oddzielonym delikatną linią (jak w projekcie referencyjnym). */
.violations {
  min-width: 0;

  /* Wysokość wiersza — ta sama metryka co w sąsiednich panelach rzędu:
     wiersz „Miejsca pomiaru" (`--location-row-height`), wiersz checkboxów
     w „Kategoriach pojazdów" i w „Pasach ruchu" mają dokładnie 50 px razem
     z linią dzielącą. Wcześniej wiersz naruszeń miał 14 px paddingu z góry
     i z dołu (~54 px), więc kolumna „Przekroczenia %" rozjeżdżała się
     z panelami po prawej. */
  --violations-row-height: 50px;
}

.violations__list {
  display: flex;
  flex-direction: column;
  background: var(--surface-primary);
}

.violations__row {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  /* `min-height`, nie `height` — zachowuje się jak wysokość komórki tabeli
     w sąsiednich panelach: normalnie daje równo 50 px, a gdy dłuższe
     tłumaczenie nazwy naruszenia się zawinie, wiersz może urosnąć.
     Padding w pionie zostaje na wypadek takiego zawinięcia; przy jednej
     linii tekstu o wysokości wiersza decyduje `min-height`. */
  min-height: var(--violations-row-height);
  padding: var(--spacing-sm) var(--spacing-md);
  border-bottom: 1px solid var(--border-subtle);
}

.violations__row:last-child {
  border-bottom: 0;
}

/* Pozycja zbiorcza („Wszystkie") wyróżniona jasnym tłem. */
.violations__row--all {
  background: var(--surface-tertiary);
}

.violations__row.is-disabled .violations__value {
  color: var(--text-muted);
}

.violations__value {
  font-size: var(--font-size-sm);
  color: var(--text-primary);
}
</style>